import StickyPageHeader from '../components/common/StickyPageHeader';
import RateClassList from '../components/lists/RateClassList';
import {
  useDefaultClasses,
  useDefaultVehicles,
  useVehicleDefaultClasses,
} from '../hooks/apiHooks';
import Layout from '../layout';

const AdminRateClassesPage = ({ disableLayout, routes }) => {
  const { defaultClasses } = useDefaultClasses();
  const { defaultVehicles } = useDefaultVehicles();
  const { vehicleDefaultClasses } = useVehicleDefaultClasses();

  const content = (
    <>
      <StickyPageHeader isAdmin title="Settings / API Rate Classes" />
      <RateClassList
        defaultClasses={defaultClasses}
        id="vehicle-default-class"
        vehicleDefaultClasses={vehicleDefaultClasses}
        vehicles={defaultVehicles}
      />
    </>
  );

  if (disableLayout) return content;

  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      {content}
    </Layout>
  );
};

export default AdminRateClassesPage;
